/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type {
  ICircleIntegration,
  ICircleIntegrationInterface,
} from "../ICircleIntegration";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint16",
            name: "targetChain",
            type: "uint16",
          },
          {
            internalType: "bytes32",
            name: "mintRecipient",
            type: "bytes32",
          },
        ],
        internalType: "struct ICircleIntegration.TransferParameters",
        name: "transferParams",
        type: "tuple",
      },
      {
        internalType: "uint32",
        name: "batchId",
        type: "uint32",
      },
      {
        internalType: "bytes",
        name: "payload",
        type: "bytes",
      },
    ],
    name: "transferTokensWithPayload",
    outputs: [
      {
        internalType: "uint64",
        name: "messageSequence",
        type: "uint64",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "encodedWormholeMessage",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "circleBridgeMessage",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "circleAttestation",
            type: "bytes",
          },
        ],
        internalType: "struct ICircleIntegration.RedeemParameters",
        name: "params",
        type: "tuple",
      },
    ],
    name: "redeemTokensWithPayload",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "token",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "sourceDomain",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "targetDomain",
            type: "uint32",
          },
          {
            internalType: "uint64",
            name: "nonce",
            type: "uint64",
          },
          {
            internalType: "bytes32",
            name: "fromAddress",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "mintRecipient",
            type: "bytes32",
          },
          {
            internalType: "bytes",
            name: "payload",
            type: "bytes",
          },
        ],
        internalType: "struct ICircleIntegration.DepositWithPayload",
        name: "depositWithPayload",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "chainId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "chainId_",
        type: "uint16",
      },
    ],
    name: "getDomainFromChainId",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "domain",
        type: "uint32",
      },
    ],
    name: "getChainIdFromDomain",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32",
      },
    ],
    name: "isMessageConsumed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ICircleIntegration__factory {
  static readonly abi = _abi;
  static createInterface(): ICircleIntegrationInterface {
    return new utils.Interface(_abi) as ICircleIntegrationInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICircleIntegration {
    return new Contract(address, _abi, signerOrProvider) as ICircleIntegration;
  }
}
